import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { NoticeData } from '../models/models'

export class SaveNoticeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/SetHomepageNotice',
      requesterInfo,
    })
  }

  public async saveNoticeApi(request: NoticeData): Promise<NoticeData> {
    return await this.postAsync<NoticeData>(request)
  }
}
